import urlFilter from "../filters/url.filter";
import { ShowCaseActionType } from "./enums/showCaseActionType"; 

/** Класс для данных витрины */
export class ShowcaseData {

  /**
  * Заголовок элемента витрины.
  */
  public Caption: string = "";

  /**
  * URL каритнки элемента витрины.
  */
  public Image: string = "";

  /**
  * URL каритнки мобильного приложения элемента витрины.
  */
  public ImageMp: string = "";

  /**
  * Тип действия элемента витрины.
  */
  public ActionType: ShowCaseActionType = ShowCaseActionType.None;

  /**
  * URL для действия элемента витрины.
  */
  public ActionLink: string = "";

  /**
  * Признак отображения элемента в витрине
  */
  public EnableWeb: boolean = false;


  constructor(src: any) {
    this.Caption = src.caption ?? '';
    this.Image = urlFilter(src.imageWeb ? src.imageWeb : src.image ?? '');
    this.ImageMp = urlFilter(src.image ? src.image : '');
    this.ActionType = (src.actionType ?? '') as ShowCaseActionType;
    this.ActionLink = src.actionLink ?? '';
    this.EnableWeb = src.enableWeb === 'true';
  }
}